import withList from '../../with-list/main';
import { selectors, actions } from './';
import table from './table-initial-data';

export default withList(selectors, actions, table, {
	link: '/banners/images/editor',
	text: 'Create banner image'
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/image/list/main.js